import { render, staticRenderFns } from "./Cribs.vue?vue&type=template&id=5d981059&scoped=true"
import script from "./Cribs.vue?vue&type=script&lang=ts"
export * from "./Cribs.vue?vue&type=script&lang=ts"
import style0 from "./Cribs.vue?vue&type=style&index=0&id=5d981059&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d981059",
  null
  
)

export default component.exports